import { Alert, Col, Modal, Row } from "antd";
import dayjs from "dayjs";
import CalendarIssuesProvider, { useCalendarIssues } from "./context";
import Tasks from "components/Tasks";
import Header from "./components/Header";
import ConfirmModal from "./components/ConfirmModal";

import AsidePanel from "./components/AsidePanel";
import WeekScheduler from "./components/WeekScheduler";
import MonthScheduler from "./components/MonthScheduler";

const CalendarContent = () => {
  const { view_type, holidays, tasks, calendar_date, refetchTasks } =
    useCalendarIssues();

  return (
    <div className="calendar__container">
      <Header />
      <Row gutter={24}>
        <Col lg={view_type === "day" ? 12 : 24} md={24} xs={24}>
          {view_type === "month" ? <MonthScheduler /> : <WeekScheduler />}
        </Col>
        {view_type === "day" && (
          <Col lg={12} md={24} xs={24} style={{ marginTop: 66 }}>
            {holidays?.map(({ date, name }, index) => (
              <Alert
                style={{ marginBottom: 10 }}
                key={index}
                type="error"
                message={`${date} - ${name}`}
              />
            ))}
            <Tasks
              date={dayjs(calendar_date).format("YYYY-MM-DD")}
              data={tasks}
              refetch={refetchTasks}
            />
          </Col>
        )}
      </Row>
      <ConfirmModal />
      <AsidePanel />
    </div>
  );
};

const CalendarModalContent = () => {
  const { onCancel } = useCalendarIssues();
  return (
    <Modal
      destroyOnHidden
      centered
      width="100%"
      size="large"
      maskClosable={false}
      title=""
      open={true}
      onCancel={onCancel}
      cancelText="Anuluj"
      okText={null}
      footer={null}
    >
      <CalendarContent />
    </Modal>
  );
};

const CalendarIssues = ({
  worker_id,
  issue_id,
  view_type,
  origin_source,
  date,
  handleClose,
  handleConfirm,
  show_in_modal = true,
  onWorkerChange,
  onDateChange,
  onViewTypeChange,
}) => {
  if (!date) {
    return null;
  }
  return (
    <CalendarIssuesProvider
      origin_source={origin_source}
      worker_id={worker_id}
      issue_id={issue_id}
      view_type={view_type}
      date={date}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      onWorkerChange={onWorkerChange}
      onDateChange={onDateChange}
      onViewTypeChange={onViewTypeChange}
    >
      {show_in_modal ? <CalendarModalContent /> : <CalendarContent />}
    </CalendarIssuesProvider>
  );
};

export default CalendarIssues;
